import script from "./UserTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTickets.vue?vue&type=script&setup=true&lang=js"

import "./UserTickets.vue?vue&type=style&index=0&id=171197ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171197ee"]])

export default __exports__